// extracted by mini-css-extract-plugin
export default {"banners":"BannersComponent_banners__fBPqq","separationBanner":"BannersComponent_separationBanner__ugmi8","textContainer":"BannersComponent_textContainer__5yjUC"};